export enum SignUpBusinessErrorsEnum {
  INCORRECT_NAME = 'Пожалуйста, введите корректрное название.',
  INCORRECT_ADDRESS = 'Пожалуйста, введите корректрный адресс.',
  INCORRECT_PHONE = 'Пожалуйста, введите корректный номер телефона.',
  INCORRECT_LINK = 'Пожалуйста, введите корректнyю ссылку на сайт.',
  INCORRECT_DESCRIPTION = 'Не корректное описание, больше 100 символов.',
}
